{
    "LogFileDownload_DownloadTitle": "Scaricamento **{}**",
    "LogFileDownload_HowManyFiles": "Quanti file precedenti desideri scaricare?",
    "LogFileDownload_AllFiles": "Tutti i file",
    "LogFileDownload_NFile": "File {} passati",
    "LogFileDownload_CurrentFile": "File corrente",
    "NAME": "LanguageLogFileDownload"
}